import {
  TAdminIssuesCounts,
  TAuditedEventsCount,
  TBWTypes,
  TCorePage,
  TEventsCount,
  TKhattabatFunnelStatsData,
  TReceiptCompensationTitles,
  TReport,
  TSubscriptionType,
  TTransferUserPackagePreview,
  TTransferUserPackageResult,
  TUserVipTimeType,
  E_TRANSFER_PACKAGE_TYPE
} from "../Types";
import { Ti18nKeys } from "./i18n";

export const MAX_PROMOCODE_REWARD_IN_HOURS = 100;

export const MAX_PROMOCODE_GENERATION_COUNT = 20;

// Et3TextInput renders its placeHolder whenever a numeric value is not positive,
// so -1 is the "nothing entered yet" sentinel for user-id inputs.
export const EMPTY_USER_ID = -1;

export const DEFAULT_TRANSFER_USER_PACKAGE_RESULT: TTransferUserPackageResult = {
  type: E_TRANSFER_PACKAGE_TYPE.VIP,
  package: "",
  fromUserId: EMPTY_USER_ID,
  toUserId: EMPTY_USER_ID,
  previousExpiry: 0,
  newExpiry: 0,
  sourceStatus: "",
  targetStatus: ""
};

export const DEFAULT_TRANSFER_USER_PACKAGE_PREVIEW: TTransferUserPackagePreview =
  {
    type: E_TRANSFER_PACKAGE_TYPE.VIP,
    package: "",
    fromUserId: EMPTY_USER_ID,
    toUserId: EMPTY_USER_ID,
    currentExpiry: 0,
    newExpiry: 0,
    remainingQuotas: [],
    remainingBalances: []
  };

export const COMMENTS_DEFAULT_NUMBER = 5;
export const MINIMUM_COMMENT_CHARACTERS = 5;
export const MAXIMUM_COMMENT_CHARACTERS = 500;

export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 20;

export const MAX_GIVE_VIP_IN_DAYS = 365;
export const MAX_GIVE_VIP_IN_HOURS = 23;
export const MAX_GIVE_VIP_IN_MIN = 59;

export const MAX_GIVE_PLUS_IN_DAYS = 30;
export const MAX_GIVE_PLUS_IN_HOURS = 23;
export const MAX_GIVE_PLUS_IN_MIN = 59;

export const MAX_GIVE_ALKHATTABAT_IN_DAYS = 30;
export const MAX_GIVE_ALKHATTABAT_IN_HOURS = 23;
export const MAX_GIVE_ALKHATTABAT_IN_MIN = 59;

export const MAX_GIVE_SILVER_IN_DAYS = 90;
export const MAX_GIVE_SILVER_IN_HOURS = 23;
export const MAX_GIVE_SILVER_IN_MIN = 59;
export const MIN_GIVE_SILVER_IN_DAYS = 7;

export const MAX_GIVE_GOLD_IN_DAYS = 90;
export const MAX_GIVE_GOLD_IN_HOURS = 23;
export const MAX_GIVE_GOLD_IN_MIN = 59;
export const MIN_GIVE_GOLD_IN_DAYS = 7;

export const MAX_GIVE_PLATINUM_IN_DAYS = 90;
export const MAX_GIVE_PLATINUM_IN_HOURS = 23;
export const MAX_GIVE_PLATINUM_IN_MIN = 59;
export const MIN_GIVE_PLATINUM_IN_DAYS = 7;

export const MAX_GIVE_ADVANCED_IN_DAYS = 90;
export const MAX_GIVE_ADVANCED_IN_HOURS = 23;
export const MAX_GIVE_ADVANCED_IN_MIN = 59;
export const MIN_GIVE_ADVANCED_IN_DAYS = 1;

export const MAX_GIVE_BLACK_IN_DAYS = 90;
export const MAX_GIVE_BLACK_IN_HOURS = 23;
export const MAX_GIVE_BLACK_IN_MIN = 59;
export const MIN_GIVE_BLACK_IN_DAYS = 7;

export const MAX_NUMBER_OF_COMMENTS = 50;

export const MAXIMUM_PROMOCODE_CHARACTERS = 6;

export const MAX_APP_MESSAGE_LENGTH = 400;
export const DEFAULT_TIME = "1970-01-01 00:00:00";

export const SILENT_BANNED_FLAG = 1;
export const PICTURE_IS_ACTIVE = 1;
export const PICTURE_IS_DELETED = 0;

export const SHOW_TBW_SAVE_BUTTON: TBWTypes[] = [
  "banned",
  "temporary_banned",
  "silent_banned",
  "warning",
  "banned",
  "flagged",
  ""
];

export const SHOW_TBW_INVESTIGATE_BUTTON: TBWTypes[] = [
  "flagged",
  "investigate",
  "temporary_banned",
  ""
];

export const TBW_INVESTIGATE_ONLY: TBWTypes[] = ["investigate"];

export const TBW_INVESTIGATE_WITH_WARN: TBWTypes[] = [
  "",
  "banned",
  "temporary_banned",
  "flagged"
];

export const MAX_ALL_MESSAGES_LIMIT = 200;

export const MAX_TYPED_MESSAGES_LIMIT = 50;

export const ALL_MESSAGES_LOAD_MORE = 200;

export const TYPED_MESSAGES_LOAD_MORE = 100;
export const TEMPORARY_BAN_DEFAULT_DAYS_NUMBER = 5;

export const MINIMUM_REPORTS_BY_TYPE_LIMIT = 5;
export const INVESTIGATION_CASES_LIMIT = 10;

export const MAX_DESCRIPTION_LENGTH = 250;
export const MIN_DESCRIPTION_LENGTH = 25;
export const MAX_PERCENTAGE_VALUE = 100;
export const MIN_PERCENTAGE_VALUE = 70;

export const CUSTOMER_SUPPORT_ROLE = "Customer Support";

export const ISSUES_ARRAY = [
  {
    label: "All",
    value: "all"
  },
  {
    label: "No Issue",
    value: "no_issue"
  },
  { label: "Minor Issue", value: "minor" },
  { label: "Major Issue", value: "major" }
];

export const PROMO_CODE_PAID_OPTION_VALUES = [
  { label: "All", value: "-1" },
  { label: "Not Paid", value: "0" },
  { label: "Paid", value: "1" }
];

export const MAX_NUMBER_ROWS = 100;

export const PROMO_CODE_GENDER_OPTIONS = [
  { label: "All", value: "ALL" },
  { label: "Male", value: "m" },
  { label: "Female", value: "f" }
];

export const PROMO_CODE_ACTIVE_OPTIONS = [
  { label: "Active", value: "1" },
  { label: "Not Active", value: "0" }
];

export const PROMO_CODE_REWARD_TYPE_OPTIONS = [
  { label: "VIP", value: "VIP" },
  { label: "ADVANCED", value: "ADVANCED" },
  { label: "STARTER", value: "STARTER" }
];
export const MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED = 17;

export const BACK_TO_TOP_PAGES_ARRAY: TCorePage[] = [
  "USER_ADVANCED",
  "USER_MESSAGES",
  "USER_CONVERSATIONS",
  "USER_EVENTS",
  "USER_PAYMENTS"
];

export const SUPERVISOR_RECEIPT_DEFAULT_CONFIGURATION = {
  id: 0,
  descriptionThreshold: 0.0,
  descriptionDiscount: 0.0,
  descriptionPricing: 0.0,
  pictureThreshold: 0.0,
  pictureDiscount: 0.0,
  picturePricing: 0.0,
  reportThreshold: 0.0,
  reportDiscount: 0.0,
  reportPricing: 0.0,
  investigationCasesThreshold: 0.0,
  investigationCasesDiscount: 0.0,
  investigationCasesPricing: 0.0,
  createdOn: `${new Date()}`
};

export const MAXIMUM_NUMBERS_BEFORE_DOT = 4;
export const MAXIMUM_NUMBERS_AFTER_DOT = 2;
export const TWO_DOTS = 2;
export const ONE_DOT = 1;
export const NEGATIVE_VALUE = -1;
export const ZERO_VALUE = 0;
export const SUPERVISOR_SUBMIT_BUTTON_MIN_DATE_ENABLED = 23;
export const SUPERVISOR_SUBMIT_BUTTON_MAX_DATE_ENABLED = 25;
export const PERCENTAGE_CONVERSION_FACTOR = 100;

export const CURRENT_MONTH_CALCULATION_ARRAY: TReceiptCompensationTitles[] = [
  "description",
  "picture",
  "report",
  "investigationCases"
];

export const ADMIN_DEFAULT_ISSUES_COUNT: TAdminIssuesCounts = {
  investigationCaseIssuesCount: 0,
  reportIssuesCount: 0,
  descriptionIssuesCount: 0,
  pictureIssuesCount: 0,
  adminID: 0
};

export const ADMIN_EVENT_COUNTS_DEFAULTS: TEventsCount = {
  reportEventCount: 0,
  investigationCasesEventCount: 0,
  pictureEventCount: 0,
  descriptionEventCount: 0
};

export const ADMIN_AUDITED_EVENT_COUNTS_DEFAULTS: TAuditedEventsCount = {
  reportAuditedCount: 0,
  investigationCasesAuditedCount: 0,
  pictureAuditedCount: 0,
  descriptionAuditedCount: 0
};

export const CONFIGURATION_RECEIPT_DEFAULTS = {
  description: {
    discount: 0,
    price: 0,
    threshold: 0
  },
  picture: {
    discount: 0,
    price: 0,
    threshold: 0
  },
  report: {
    discount: 0,
    price: 0,
    threshold: 0
  },
  investigationCases: {
    discount: 0,
    price: 0,
    threshold: 0
  }
};

export const SUPERVISOR_CURRENT_MONTH_DEFAULTS = {
  id: 0,
  finalSalary: 0,
  description: {
    price: 0,
    discount: 0
  },
  picture: {
    price: 0,
    discount: 0
  },
  report: {
    price: 0,
    discount: 0
  },
  investigationCases: {
    price: 0,
    discount: 0
  }
};

export const DAYS_KEYS: Ti18nKeys[] = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY"
];

export const DEFAULT_REPORT_OBJECT: TReport = {
  status: "pending",
  reportId: 0,
  reason1: 0,
  reason2: 0,
  reason3: 0,
  reason4: 0,
  reason5: 0,
  comment: "",
  reportedOn: "",
  reporterId: 0,
  reporterUUID: "",
  reporterUsername: "",
  reporterGender: "f",
  reporterCreatedOn: "",
  reporterLoginCount: 0,
  reportedId: 0,
  reportedUUID: "",
  reportedUsername: "",
  reportedGender: "f",
  reportedCreatedOn: "",
  reportedLoginCount: 0,
  reportedIsSilentBanned: 0,
  conversation: {},
  reporterPaid: {
    isReporterPaidVIP: false,
    isReporterPaidPlus: false,
    isReporterPaidAlkhattabat: false,
    isReporterPaidBoost: false,
    isReporterPaidRewind: false,
    isReporterSubscribedVIP: false,
    isReporterSubscribedPlus: false,
    isReporterSubscribedAlkhattabat: false,
    isReporterSubscribedBoost: false,
    isReporterSubscribedRewind: false,
    isReporterPaidSilver: false,
    isReporterPaidGold: false,
    isReporterPaidBlack: false,
    isReporterPaidPlatinum: false,
    isReporterPaidPower: false,
    isReporterSubscribedSilver: false,
    isReporterSubscribedGold: false,
    isReporterSubscribedBlack: false,
    isReporterSubscribedPlatinum: false,
    isReporterSubscribedPower: false,
    wasReporterStripeUser: false
  },
  reportedPaid: {
    isReportedPaidVIP: false,
    isReportedPaidPlus: false,
    isReportedPaidAlkhattabat: false,
    isReportedPaidBoost: false,
    isReportedPaidRewind: false,
    isReportedSubscribedVIP: false,
    isReportedSubscribedPlus: false,
    isReportedSubscribedAlkhattabat: false,
    isReportedSubscribedBoost: false,
    isReportedSubscribedRewind: false,
    isReportedPaidSilver: false,
    isReportedPaidGold: false,
    isReportedPaidBlack: false,
    isReportedPaidPlatinum: false,
    isReportedPaidPower: false,
    isReportedSubscribedSilver: false,
    isReportedSubscribedGold: false,
    isReportedSubscribedBlack: false,
    isReportedSubscribedPlatinum: false,
    isReportedSubscribedPower: false,
    wasReportedStripeUser: false
  },
  reporterTempBanCount: 0,
  reportedTempBanCount: 0,
  reporterWarnCount: 0,
  reportedWarnCount: 0,
  reporterTester: false,
  reportedTester: false,
  isReportIndonesianMalaysian: false
};

export const CODE_LENGTH = 6;

export const GENDER_COLORED_TABLE_NAMES = [
  "USER_CONVERSATIONS",
  "USER_MESSAGES",
  "USER_MESSAGE_ID"
];

export const ALLOWED_UPLOADED_IMAGES_TYPES = [".png", ".jpg", ".jpeg", ".gif"];

export const MAX_UPLOADED_IMAGE_SIZE_IN_MB = 0.5;

export const QUALITY_REDUCE_RATIO = 0.8;

export const STANDARD_IMAGE_DEFAULT_SIZE = 1024 * 1024;

export const KHATTABAT_FUNNEL_STATS_DEFAULT_DATA: TKhattabatFunnelStatsData = {
  apply: 0,
  toBeInformed: 0,
  applied: 0,
  doNotInform: 0,
  accepted: 0,
  rejected: 0,
  deleted: 0,
  ongoing: 0,
  paying: 0,
  cancelled: 0,
  refunded: 0,
  active: 0
};

export const SUBSCRIPTION_MAX_VALUES: {
  [key in TSubscriptionType]: { [timeType in TUserVipTimeType]: number };
} = {
  VIP: {
    DAYS: MAX_GIVE_VIP_IN_DAYS,
    HOURS: MAX_GIVE_VIP_IN_HOURS,
    MINUTES: MAX_GIVE_VIP_IN_MIN
  },
  PLUS: {
    DAYS: MAX_GIVE_PLUS_IN_DAYS,
    HOURS: MAX_GIVE_PLUS_IN_HOURS,
    MINUTES: MAX_GIVE_PLUS_IN_MIN
  },
  ALKHATTABAT: {
    DAYS: MAX_GIVE_ALKHATTABAT_IN_DAYS,
    HOURS: MAX_GIVE_ALKHATTABAT_IN_HOURS,
    MINUTES: MAX_GIVE_ALKHATTABAT_IN_MIN
  },
  SILVER: {
    DAYS: MAX_GIVE_SILVER_IN_DAYS,
    HOURS: MAX_GIVE_SILVER_IN_HOURS,
    MINUTES: MAX_GIVE_SILVER_IN_MIN
  },
  GOLD: {
    DAYS: MAX_GIVE_GOLD_IN_DAYS,
    HOURS: MAX_GIVE_GOLD_IN_HOURS,
    MINUTES: MAX_GIVE_GOLD_IN_MIN
  },
  PLATINUM: {
    DAYS: MAX_GIVE_PLATINUM_IN_DAYS,
    HOURS: MAX_GIVE_PLATINUM_IN_HOURS,
    MINUTES: MAX_GIVE_PLATINUM_IN_MIN
  },
  ADVANCED: {
    DAYS: MAX_GIVE_ADVANCED_IN_DAYS,
    HOURS: MAX_GIVE_ADVANCED_IN_HOURS,
    MINUTES: MAX_GIVE_ADVANCED_IN_MIN
  },
  BLACK: {
    DAYS: MAX_GIVE_BLACK_IN_DAYS,
    HOURS: MAX_GIVE_BLACK_IN_HOURS,
    MINUTES: MAX_GIVE_BLACK_IN_MIN
  }
};

export const SUBSCRIPTION_MIN_VALUES: Partial<{
  [key in TSubscriptionType]: Partial<{
    [timeType in TUserVipTimeType]: number;
  }>;
}> = {
  SILVER: { DAYS: MIN_GIVE_SILVER_IN_DAYS },
  GOLD: { DAYS: MIN_GIVE_GOLD_IN_DAYS },
  PLATINUM: { DAYS: MIN_GIVE_PLATINUM_IN_DAYS },
  ADVANCED: { DAYS: MIN_GIVE_ADVANCED_IN_DAYS },
  BLACK: { DAYS: MIN_GIVE_BLACK_IN_DAYS }
};

export const SUBSCRIPTION_MAX_MESSAGE_KEYS: {
  [key in TSubscriptionType]: { [timeType in TUserVipTimeType]: Ti18nKeys };
} = {
  VIP: { DAYS: "VIP_IN_DAYS", HOURS: "VIP_IN_HOURS", MINUTES: "VIP_IN_MIN" },
  PLUS: {
    DAYS: "PLUS_IN_DAYS",
    HOURS: "PLUS_IN_HOURS",
    MINUTES: "PLUS_IN_MIN"
  },
  ALKHATTABAT: {
    DAYS: "KHATTABAT_IN_DAYS",
    HOURS: "KHATTABAT_IN_HOURS",
    MINUTES: "KHATTABAT_IN_MIN"
  },
  SILVER: {
    DAYS: "SILVER_IN_DAYS",
    HOURS: "SILVER_IN_HOURS",
    MINUTES: "SILVER_IN_MIN"
  },
  GOLD: {
    DAYS: "GOLD_IN_DAYS",
    HOURS: "GOLD_IN_HOURS",
    MINUTES: "GOLD_IN_MIN"
  },
  PLATINUM: {
    DAYS: "PLATINUM_IN_DAYS",
    HOURS: "PLATINUM_IN_HOURS",
    MINUTES: "PLATINUM_IN_MIN"
  },
  ADVANCED: {
    DAYS: "ADVANCED_IN_DAYS",
    HOURS: "ADVANCED_IN_HOURS",
    MINUTES: "ADVANCED_IN_MIN"
  },
  BLACK: {
    DAYS: "BLACK_IN_DAYS",
    HOURS: "BLACK_IN_HOURS",
    MINUTES: "BLACK_IN_MIN"
  }
};

export const SUBSCRIPTION_MIN_MESSAGE_KEYS: Partial<{
  [key in TSubscriptionType]: Partial<{
    [timeType in TUserVipTimeType]: Ti18nKeys;
  }>;
}> = {
  SILVER: { DAYS: "SILVER_IN_DAYS_MIN" },
  GOLD: { DAYS: "GOLD_IN_DAYS_MIN" },
  PLATINUM: { DAYS: "PLATINUM_IN_DAYS_MIN" },
  BLACK: { DAYS: "BLACK_IN_DAYS_MIN" }
};

export const SUBSCRIPTION_CONFIRMATION_POPUP_KEYS: {
  [key in TSubscriptionType]: Ti18nKeys;
} = {
  VIP: "VIP_CONFIRMATION_POPUP",
  PLUS: "PLUS_CONFIRMATION_POPUP",
  ALKHATTABAT: "KHATTABAT_CONFIRMATION_POPUP",
  SILVER: "SILVER_CONFIRMATION_POPUP",
  GOLD: "GOLD_CONFIRMATION_POPUP",
  PLATINUM: "PLATINUM_CONFIRMATION_POPUP",
  ADVANCED: "ADVANCED_CONFIRMATION_POPUP",
  BLACK: "BLACK_CONFIRMATION_POPUP"
};
